import { client } from "../api/client";

const fmtTime = (value) => {
  if (!value) return "00:00";
  const s = String(value);
  return s.length >= 5 ? s.slice(0, 5) : s;
};

/**
 * Liste { id, name } pour les selects (lots gagnants, etc.)
 */
export async function fetchDrawOptions() {
  const fromDrawConfigs = (raw) => {
    if (!raw) return [];
    const arr = Array.isArray(raw) ? raw : raw.draws || [];
    return arr
      .map((item) => {
        const draw = item?.draw ?? item;
        const id = draw?.id ?? item?.id;
        const name = draw?.name ?? item?.name;
        if (id == null || !name) return null;
        return { id: String(id), name: String(name) };
      })
      .filter(Boolean);
  };

  const fromFilters = (raw) => {
    if (!raw?.draws) return [];
    return raw.draws
      .map((d) => {
        if (d?.id == null || !d?.name) return null;
        return { id: String(d.id), name: String(d.name) };
      })
      .filter(Boolean);
  };

  try {
    const data = await client("draw-configs/");
    const list = fromDrawConfigs(data);
    if (list.length > 0) return list;
    console.warn("[draws] draw-configs/ vide:", data);
  } catch (e) {
    console.warn("[draws] draw-configs/ erreur:", e);
  }

  try {
    const filters = await client("reports/filters/");
    const list = fromFilters(filters);
    if (list.length > 0) return list;
    console.warn("[draws] reports/filters/ vide:", filters);
  } catch (e) {
    console.warn("[draws] reports/filters/ erreur:", e);
  }

  return [];
}

/**
 * Liste complète pour la page Configurations → Tirages (horaires, actif, etc.)
 */
export async function fetchDrawConfigs() {
  try {
    const data = await client("draw-configs/");
    const arr = Array.isArray(data) ? data : (data?.draws || []);
    if (arr.length > 0) {
      const now = new Date();
      const currentMinutes = now.getHours() * 60 + now.getMinutes();

      const parseMinutes = (t) => {
        if (!t) return 0;
        const [h, m] = String(t).split(':').map(Number);
        return (h || 0) * 60 + (m || 0);
      };

      return arr
        .map((item) => {
          const draw = item?.draw;
          if (!draw?.id || !draw?.name) return null;
          const cfg = item?.config || {};

          const openTime = fmtTime(cfg.custom_open_time || draw.default_open_time);
          const closeTime = fmtTime(cfg.custom_close_time || draw.default_close_time);
          const defaultOpenTime = fmtTime(draw.default_open_time);
          const defaultCloseTime = fmtTime(draw.default_close_time);

          const openMin = parseMinutes(openTime);
          const closeMin = parseMinutes(closeTime);
          const isActive = cfg.is_active !== false;

          let isOpen = false;
          if (isActive) {
            if (openMin <= closeMin) {
              isOpen = currentMinutes >= openMin && currentMinutes < closeMin;
            } else {
              // Overnight draw
              isOpen = currentMinutes >= openMin || currentMinutes < closeMin;
            }
          }

          return {
            id: draw.id,
            name: draw.name,
            open: openTime,
            close: closeTime,
            defaultOpen: defaultOpenTime,
            defaultClose: defaultCloseTime,
            hasCustomClose: Boolean(cfg.custom_close_time),
            status: isOpen ? "Ouvert" : "Fermé",
            active: isActive,
            isOpen: isOpen,
          };
        })
        .filter(Boolean);
    }
  } catch (e) {
    console.warn("[draws] fetchDrawConfigs erreur:", e);
  }

  // Secours : id + nom seulement
  const options = await fetchDrawOptions();
  return options.map((d) => ({
    id: Number(d.id) || d.id,
    name: d.name,
    open: "00:00",
    close: "23:59",
    defaultOpen: "00:00",
    defaultClose: "23:59",
    hasCustomClose: false,
    status: "Fermé",
    active: true,
    isOpen: false,
  }));
}
